import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";
import {convertObjectToFormData} from "../../../../Utilities/Api/apiUtility";

class serverLoanLibraryCatalogItemApi {
    static getLoanLibraryCatalogItem(loanLibraryCatalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog/${loanLibraryCatalogItemId}`,
                requestTypes.GET,
            ),
        );
    }

    static addLoanLibraryCatalogItemWithInventory(catalogWithInventory: Record<string, unknown>) {
        const formData = convertObjectToFormData(catalogWithInventory);
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.POST,
                formData,
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_ADDED,
                apiConstants.contentType.MULTI,
            ),
        );
    }

    static updateLoanLibraryCatalogItemWithInventory(catalogItemId: string, catalogWithInventory: Record<string, unknown>) {
        const formData = convertObjectToFormData(catalogWithInventory);
        return sendRequest(
            requestOptions(config.URL + `loan-library/catalog`,
                requestTypes.PUT,
                formData,
                apiConstants.successMessage.loanLibrary.CATALOG_ITEM_UPDATED,
                apiConstants.contentType.MULTI,
            ),
        );
    }
}

export const loanLibraryCatalogItemApi = config.environment.MODE === config.modes.SERVER ? serverLoanLibraryCatalogItemApi : serverLoanLibraryCatalogItemApi;
